import { Box, BoxProps } from '@mui/material';
import React from 'react';

const FlexBetween: React.FC<BoxProps & { fullWidth?: boolean }> = ({ children, ...props }) => (
    <Box display="flex" alignItems="center" justifyContent="space-between" {...props}>
        {children}
    </Box>
);

export default FlexBetween;
